import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  specialistsCollection,
  notificationsCollection,
  questionsCollection,
  helpsCollection,
} from "~/const/firestore";
import { Specialist } from "~/types/specialist";
import { Notification } from "~/types/notification";
import { Question } from "~/types/question";
import { Help } from "~/types/help";
import {
  convertToSpecialists,
  convertToNotifications,
  convertToHelps,
  convertToQuestions,
} from "~/helpers/snapshot";

// 専門家データ 取得
export const getSpecialist = createAsyncThunk<Specialist[], void>(
  "admin/data/specialist",
  async () => {
    try {
      const snapshot = await specialistsCollection
        .orderBy("created", "desc")
        .get();
      const specialists = convertToSpecialists(snapshot);
      return specialists;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);

// 通知データ 取得
export const getNotification = createAsyncThunk<Notification[], void>(
  "admin/data/notification",
  async () => {
    try {
      const snapshot = await notificationsCollection
        .orderBy("created", "desc")
        .get();
      const notifications = convertToNotifications(snapshot);
      return notifications;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);

// ヘルプデータ 取得
export const getHelp = createAsyncThunk<Help[], void>(
  "admin/data/help",
  async () => {
    try {
      const snapshot = await helpsCollection.orderBy("created", "desc").get();
      const helps = convertToHelps(snapshot);
      return helps;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);

// 会話パターンデータ 取得
export const getQuestion = createAsyncThunk<Question[], void>(
  "admin/data/question",
  async () => {
    try {
      const snapshot = await questionsCollection.orderBy("categoryId").get();
      const questions = convertToQuestions(snapshot);
      return questions;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);
